// export const prefix = process.env.NODE_ENV === "development" ? '/api' : ''
// export const api =  process.env.NODE_ENV === "development" ? '' : 'https://local.vrmaker.vip:37086' 

export const prefix = process.env.NODE_ENV === "development" ? '' : ''
// export const api =  process.env.NODE_ENV === "development" ? 'http://192.168.33.99' : 'http://192.168.33.99' 
// export const api = process.env.NODE_ENV === "development" ? 'http://192.168.33.251/' : 'http://192.168.33.251/'  // 黄渊
// export const api =  process.env.NODE_ENV === "development" ? 'http://220.249.101.248:37086/' : 'http://220.249.101.248:37086/'  // 测试环境
export const api =  process.env.NODE_ENV === "development" ? 'https://local.vrmaker.vip:37086' : 'https://local.vrmaker.vip:37086' // 过期域名
export const defaulturl = process.env.NODE_ENV === "development" ? 'https://local.vrmaker.com.cn/api' : 'https://local.vrmaker.com.cn/api' // 新域名
// export const defaulturl = process.env.NODE_ENV === "development" ? 'https://www.energydt.cn/proxy/ebs-web3.0/' : 'https://www.energydt.cn/proxy/ebs-web3.0/'
















